import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";

/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import { TableActions, ColorBatch } from 'components';
import { dateFormat, paymentCollectionStatusName, paymentCollectionStatusColorMap, paymentTypeName } from 'enums';
import { convertToAdditionalCurrency } from 'utils';
import { detailsBtn } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var paymentsListColumns = function paymentsListColumns(roleData, windowWidth) {
  return [{
    name: 'ИД',
    render: function render(_ref) {
      var id = _ref.id;
      return ___EmotionJSX("span", {
        "data-value": "payment.id"
      }, id);
    },
    width: '60px'
  }, {
    name: 'Дата',
    value: 'date',
    dateTimeFormat: dateFormat,
    width: '100px'
  }, {
    name: 'Служител',
    render: function render(_ref2) {
      var employee = _ref2.employee;
      return ___EmotionJSX("span", {
        "data-value": "payment.employee"
      }, employee === null || employee === void 0 ? void 0 : employee.name);
    },
    width: '120px',
    invisibleBelow: 1200
  }, {
    name: 'Начин на плащане',
    render: function render(_ref3) {
      var payment_type = _ref3.payment_type;
      return ___EmotionJSX("span", {
        "data-value": "payment.payment_type"
      }, paymentTypeName[payment_type] || '-');
    },
    width: '120px',
    invisibleBelow: 3000
  }, {
    name: 'Кредит №',
    render: function render(_ref4) {
      var credit = _ref4.credit;
      return ___EmotionJSX(Link, {
        "data-value": "payment.credit_number",
        to: "/credits/details/".concat(credit === null || credit === void 0 ? void 0 : credit.id)
      }, credit === null || credit === void 0 ? void 0 : credit.number);
    },
    width: '110px'
  }, {
    name: 'Сума',
    render: function render(_ref5) {
      var total_amount = _ref5.total_amount,
          currency = _ref5.currency;
      return ___EmotionJSX("div", null, ___EmotionJSX("p", {
        "data-value": "payment.total_amount"
      }, total_amount, " ", currency), ___EmotionJSX("p", null, convertToAdditionalCurrency({
        value: total_amount,
        fromCurrency: currency
      })));
    },
    width: '110px'
  }, {
    name: 'Посредник',
    render: function render(_ref6) {
      var franchisee = _ref6.franchisee;
      return ___EmotionJSX("span", {
        "data-value": "payment.franchisee"
      }, franchisee === null || franchisee === void 0 ? void 0 : franchisee.name);
    },
    width: '140px',
    invisibleBelow: 1000
  }, {
    name: 'Статус',
    render: function render(_ref7) {
      var collection_status = _ref7.collection_status;
      return ___EmotionJSX(ColorBatch, {
        type: paymentCollectionStatusColorMap[collection_status]
      }, paymentCollectionStatusName[collection_status]);
    },
    width: '140px'
  }, {
    name: 'Офис',
    render: function render(_ref8) {
      var office = _ref8.office;
      return ___EmotionJSX("span", {
        "data-value": "payment.office"
      }, office === null || office === void 0 ? void 0 : office.name);
    },
    width: '120px',
    invisibleBelow: 3000
  }, {
    name: 'Партньор',
    render: function render(_ref9) {
      var partner = _ref9.partner;
      return ___EmotionJSX("span", {
        "data-value": "payment.partner"
      }, partner === null || partner === void 0 ? void 0 : partner.name);
    },
    width: '120px',
    invisibleBelow: 3000
  }, {
    name: 'Главница',
    render: function render(_ref10) {
      var amount = _ref10.amount,
          currency = _ref10.currency;
      return windowWidth > 3000 ? ___EmotionJSX("div", null, ___EmotionJSX("p", {
        "data-value": "payment.amount"
      }, amount, " ", currency), ___EmotionJSX("p", null, convertToAdditionalCurrency({
        value: amount,
        fromCurrency: currency
      }))) : ___EmotionJSX("span", {
        "data-value": "payment.amount"
      }, amount, " ", currency);
    },
    invisibleBelow: 3000
  }, {
    name: 'Лихва',
    render: function render(_ref11) {
      var interest = _ref11.interest,
          currency = _ref11.currency;
      return windowWidth > 3000 ? ___EmotionJSX("div", null, ___EmotionJSX("p", {
        "data-value": "payment.interest"
      }, interest, " ", currency), ___EmotionJSX("p", null, convertToAdditionalCurrency({
        value: interest,
        fromCurrency: currency
      }))) : ___EmotionJSX("span", {
        "data-value": "payment.interest"
      }, interest, " ", currency);
    },
    invisibleBelow: 3000
  }, {
    name: 'Лих. проср.',
    render: function render(_ref12) {
      var penalty = _ref12.penalty,
          currency = _ref12.currency;
      return windowWidth > 3000 ? ___EmotionJSX("div", null, ___EmotionJSX("p", {
        "data-value": "payment.penalty"
      }, penalty, " ", currency), ___EmotionJSX("p", null, convertToAdditionalCurrency({
        value: penalty,
        fromCurrency: currency
      }))) : ___EmotionJSX("span", {
        "data-value": "payment.penalty"
      }, penalty, " ", currency);
    },
    invisibleBelow: 3000
  }, {
    name: 'Такса ДП',
    render: function render(_ref13) {
      var home_visit_fee_amount = _ref13.home_visit_fee_amount,
          currency = _ref13.currency;
      return windowWidth > 3000 ? ___EmotionJSX("div", null, ___EmotionJSX("p", {
        "data-value": "payment.home_visit_fee_amount"
      }, home_visit_fee_amount !== null && home_visit_fee_amount !== void 0 ? home_visit_fee_amount : '0.00', " ", currency), ___EmotionJSX("p", null, convertToAdditionalCurrency({
        value: home_visit_fee_amount,
        fromCurrency: currency
      }))) : ___EmotionJSX("span", {
        "data-value": "payment.home_visit_fee_amount"
      }, home_visit_fee_amount !== null && home_visit_fee_amount !== void 0 ? home_visit_fee_amount : '0.00', " ", currency);
    },
    invisibleBelow: 3000
  }, {
    name: 'Действие',
    render: function render(payment) {
      var _payment$credit;

      return ___EmotionJSX(TableActions, {
        mainAction: {
          linkTo: {
            pathname: "/credits/details/".concat(payment === null || payment === void 0 ? void 0 : (_payment$credit = payment.credit) === null || _payment$credit === void 0 ? void 0 : _payment$credit.id),
            state: {
              credit: payment === null || payment === void 0 ? void 0 : payment.credit
            }
          },
          leftIcon: {
            iconName: 'la la-info',
            size: 20
          },
          css: detailsBtn
        }
      });
    },
    width: '90px'
  }].filter(Boolean);
};